import React from 'react'
import { AnimationOnScroll } from 'react-animation-on-scroll'
import { Col, Image, Row, Table } from 'react-bootstrap'
import { useLocation } from 'react-router-dom'

export default function MarinePlywood() {
    let image = useLocation().state.image

    return (
        <div>
            <Row className='mx-0' style={{ marginBottom: '61px' }}>
                <Col md={{ order: 'last' }} className='position-relative w-100 col-md-6 col-12 product-page-image-section mt-5 mt-md-0'>
                    <Image className='product-page-image position-absolute ' src={image} />
                </Col>
                <Col md={{ order: 'first' }} className='col-md-6 col-12'>
                    <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                        <h3 style={{ fontWeight: '800', color: '#FCCD37', textAlign: 'start' }} className='mb-4'>ABOUT THE<br /> PRODUCT</h3>
                    </AnimationOnScroll>
                    <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                        <p align='left' style={{ fontSize: '1.3em' }}>
                            Looking for the best plywood? Tired of damaged BWP grade plywood from local manufacturers?
                            <br /><br />
                            Look no further! Select the Best Marine Plywood Manufacturer in India with Kaptain Marine Plywood.
                            We are the industry favorite and the go-to marine plywood manufacturer for boats, homes, and industrial
                            uses.
                            <br /><br />
                            Marine Plywood or BWP plywood is the most premium type of plywood that can sustain 500+ hours in
                            boiling water and repel water with ease. It does not rot or warp under the presence of water, while
                            also being incredibly sturdy and strong. At Kaptain Ply, we use a state of the art quad-press technology to
                            produce a super-strong, warp-free structure with zero surface core gaps.
                            <br /><br />
                            The veneers are bonded with the most premium resin to impart resistive qualities to the plywood. The adhesive used to bind the layers is manufactured in-house. The in-house adhesive is free of toxins making the product safe for the environment. Each layer is treated with a unique combination of various toxicants by VPT (vacuum pressure treatment). These methods give a super smooth surface to the ply and give it the ability to resist borers, which ensures the quality and durability of the furniture and other builds.
                        </p>
                    </AnimationOnScroll>
                </Col>
            </Row>
            <Row>
                <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                    <h3 style={{ fontWeight: '800', color: '#FCCD37', textAlign: 'start' }} className='mb-4'>Best Marine Plywood Manufacturer in India</h3>
                </AnimationOnScroll>
                <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                    <p align='left' style={{ fontSize: '1.3em' }}>
                        We maintain our quality and our commitment to being the best marine plywood manufacturer in India
                        by using 15 layers of veneer, and top-grade 100% timber. The quality of the wood along with the
                        properties of the premium resin make our marine plywood borer-proof & termite-proof. Our precise
                        structural balance along with uniform thickness gives you the best bang for buck!
                        <br /><br />
                        Our quality has been recognized by the ISO with a BWP IS 710 rating. We meet and surpass all the requirements
                        for the certification along with setting a new benchmark.
                        <br /><br />
                        We continue to dominate the industry and put our customers first, by giving 35 years of warranty and 7 times
                        money-back guarantee, an offer that can only be bettered in your dreams!
                        <br /><br />
                        Now that you know why we are called the industry favorite, best marine plywood manufacturer in India,
                        what are you waiting for?</p>
                </AnimationOnScroll>
            </Row>
            <Row className='mx-0 justify-content-between' style={{ marginTop: '109px' }}>
                <Col md={2} className='d-flex align-items-center'>
                    <h3 style={{ fontWeight: '800', color: '#FCCD37', textAlign: 'start' }}>Product Specification</h3></Col>
                <Col md={9}>
                    <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                        <Table responsive>
                            <thead style={{ color: '#FFF' }}>
                                <tr>
                                    <th className='text-start'>TEST</th>
                                    <th className='text-start'>ISI SPECIFIED VALUE</th>
                                    <th className='text-start'>RESULT OBTAINED</th>
                                </tr>
                            </thead>
                            <tbody style={{fontWeight:'500'}}>
                                <tr style={{ color: '#FFF' }}>
                                    <td className='text-start'>Moisture</td>
                                    <td className='text-start'>5% – 15%</td>
                                    <td className='text-start'>8%</td>
                                </tr>

                                <tr style={{ backgroundColor: '#FFC700' }}>
                                    <td className='text-start'>Glue Shear Strength (Dry State)</td>
                                    <td className='text-start'>Min. Ind. 1100 N<br />
                                        Min. Avg 1350 N</td>
                                    <td className='text-start'>1350 N<br />
                                        1500 N</td>
                                </tr>

                                <tr style={{ color: '#FFF' }}>
                                    <td className='text-start'>Adhesion to plywood</td>
                                    <td className='text-start'>Min. Pass Standard</td>
                                    <td className='text-start'>Excellent</td>
                                </tr>

                                <tr style={{ backgroundColor: '#FFC700' }}>
                                    <td className='text-start'>Glue Shear Strength<br />(after 72 hrs. Boiling)</td>
                                    <td className='text-start'>Min. Ind. 800 N<br />
                                        Min. Avg 1000 N</td>
                                    <td className='text-start'>1350 N<br />
                                        1250 N</td>
                                </tr>

                                <tr style={{ color: '#FFF' }}>
                                    <td className='text-start'>Static Bending Strength
                                        <br />Modulus of Rupture
                                        <br />– Along the grain
                                        <br />– Across the grain<br />
                                    </td>
                                    <td className='text-start'>50 N /sq.mm <br />
                                        30 N /sq.mm</td>
                                    <td className='text-start'>65 N /sq.mm<br />
                                        40 N /sq.mm</td>
                                </tr>

                                <tr style={{ backgroundColor: '#FFC700' }}>
                                    <td className='text-start'>Modulus of Elasticity<br />
                                        – Along the grain<br />
                                        – Across the grain</td>
                                    <td>7500 N /sq.mm<br />
                                        4000 N /sq.mm</td>
                                    <td className='text-start'>8305 N /sq.mm<br />
                                        4170 N /sq.mm</td>
                                </tr>

                                <tr style={{ color: '#FFF' }}>
                                    <td className='text-start'>Tensile Strength<br />
                                        – Along the grain<br />
                                        – Across the grain<br />
                                        – Sum of Tensile strength</td>
                                    <td className='text-start'>42 N /sq.mm<br />
                                        25 N /sq.mm<br />
                                        84.5 N /sq.mm</td>
                                    <td className='text-start'>55 N /sq.mm<br />
                                        39 N /sq.mm<br />
                                        94 N /sq.mm</td>
                                </tr>
                                <tr style={{ backgroundColor: '#FFC700' }}>
                                    <td className='text-start'>Wet Bending Strength<br />
                                        A. Along the face grain<br />
                                        a) Modulus of Elasticity,
                                        N/mm2<br />
                                        b) Modulus of Rupture,
                                        N/mm2<br />
                                        B. Across the face grain<br />
                                        a) Modulus of Elasticity,
                                        N/mm2<br />
                                        b) Modulus of Rupture,
                                        N/mm2</td>
                                    <td>Avg: 3750 N/mm2<br />
                                        Min Ind: 3400 N/mm2<br />
                                        Avg: 25 N/mm2<br />
                                        Min Ind: 22 N/mm2<br />
                                        Avg: 2000 N/mm2<br />
                                        Min Ind: 1800 N/mm2Avg: 15 N/mm2<br />
                                        Min Ind: 13 N/mm2</td>
                                    <td className='text-start'>4650 N/mm2<br />
                                        4100 N/mm2<br />
                                        30 N/mm2<br />
                                        26 N/mm2<br />
                                        3050 N/mm2<br />
                                        2500 N/mm225 N/mm2<br />
                                        20 N/mm2</td>
                                </tr>
                            </tbody>
                        </Table>
                    </AnimationOnScroll>
                </Col>
            </Row>
        </div>
    )
}
